import { NodeBoxButton, NodeBoxButtonProps } from "../../Misc/Buttons/NodeBoxButton";

export function GearButton(props: Omit<NodeBoxButtonProps, "children">) {
  return <NodeBoxButton {...props}><i className="fa fa-gear" /></NodeBoxButton>
}